import React, { FC } from "react";
import { Button } from "@material-ui/core";
import { postRequest } from "../../../apis/axiosAction";
import Encoding from "encoding-japanese";
import { DateTime } from "luxon";
import { getFirstDayOfMonth } from "../Register/TSCheckTableDataOperation";

const TSCheckStoreScoreDataButton: FC<{
  csvZoCode?: string;
  csvDoCode?: string;
  addMonth: number;
}> = ({ csvZoCode, csvDoCode, addMonth }) => {
  const [executeFlg, setExecuteFlg] = React.useState(false);
  const [executeFlg2, setExecuteFlg2] = React.useState(false);
  const [searchZoCode] = React.useState(csvZoCode);
  const [searchDoCode] = React.useState(csvDoCode);

  // 個店毎の得点推移
  const getTSCheckData = async () => {
    let date: any = DateTime.local().toFormat("yyyyMMdd");

    const apiParams = {
      "api-name": "storeTransitionData",
      target_date: "selectedBaseDate",
      zo_code: searchZoCode,
      do_code: searchDoCode,
    };
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "tscheck/storeTransitionData-phase2";

    setExecuteFlg(true);
    return postRequest(url, apiParams)
      .then((res) => {
        let headerRow: any[] = [
          "ZOコード",
          "ZO",
          "DOコード",
          "DO",
          "OFCコード",
          "OFC",
          "店舗コード",
          "店舗名",
        ];

        let dataList: any[] = res.data.dataList;
        let sortDataList: any[] = [];
        if (dataList) {
          let resultList = dataList[0].resultList;
          let monthList = dataList[0].monthList;

          for (let j = 0; j < monthList.length; j++) {
            headerRow.push(monthList[j].name.slice(1));
          }
          for (let i = 0; i < resultList.length; i++) {
            let sortData: any = {};
            let result: any = resultList[i];
            sortData.zocode = result.zocode;
            sortData.zoname = result.zoname;
            sortData.docode = result.docode;
            sortData.doname = result.doname;
            sortData.ofc_code = result.ofc_code;
            sortData.ofc_name = result.ofc_name;
            sortData.tenpo_code = result.tenpo_code;
            sortData.tenpo_name = result.tenpo_name;
            for (let j = 0; j < monthList.length; j++) {
              sortData[monthList[j].name] = result[monthList[j].name];
            }
            sortDataList.push(sortData);
          }
        }

        const dataRows = sortDataList.map(({ tableData, ...row }) => {
          return Object.values(row);
        });

        const delimiter = ",";
        const data: any = [headerRow, ...dataRows]
          .map((e: any) => e.join(delimiter))
          .join("\n");

        let fileName = "TSCheckStoreTransitionData_" + date;

        const exportFileName = `${fileName}.csv`;

        let convertData: any = new Uint8Array(
          Encoding.convert(Encoding.stringToCode(data), "SJIS", "UNICODE")
        );
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
          new Blob([convertData], { type: "text/csv" })
        );
        a.setAttribute("download", exportFileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .finally(() => {
        setExecuteFlg(false);
      });
  };

  // 個店毎評価一覧出力
  const getStoreScoreData = async () => {
    let date: any = DateTime.local().toFormat("yyyyMMdd");
    const apiParams = {
      "api-name": "storeEvaluationData",
      target_date: addMonth,
      zo_code: searchZoCode,
      do_code: searchDoCode,
    };
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "tscheck/storeEvaluationData-phase2";

    setExecuteFlg2(true);
    return postRequest(url, apiParams)
      .then((res) => {
        let headerRow: any[] = [
          "提出日",
          "ZOコード",
          "ZO",
          "DOコード",
          "DO",
          "OFCコード",
          "OFC",
          "店舗コード",
          "店舗名",
        ];

        for (let i = 1; i <= 45; i++) {
          headerRow.push("No" + i);
          headerRow.push("No" + i + "添付");
        }
        headerRow.push("浄化槽有無");
        headerRow.push("法定点検実施有無");
        headerRow.push("法定点検実施日");
        headerRow.push("点検結果");
        headerRow.push("点検結果確認日");
  
        let dataList: any[] = res.data.dataList;
        let sortDataList: any[] = [];
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let sortData: any = {};
            let result: any = dataList[i];
            sortData.approve_day = result.approve_day;
            sortData.zocode = result.zocode;
            sortData.zoname = result.zoname;
            sortData.docode = result.docode;
            sortData.doname = result.doname;
            sortData.ofc_code = result.ofc_code;
            sortData.ofc_name = result.ofc_name;
            sortData.tenpo_code = result.tenpo_code;
            sortData.tenpo_name = result.tenpo_name;
            for (let j = 1; j <= 45; j++) {
              sortData["_" + j] = result["_" + j];
              sortData["_" + j + "p"] = result["_" + j + "p"];
            }
            sortData.septic_tank_value = result.septic_tank_value;
            sortData.inspection_value = result.inspection_value;
            sortData.inspection_day = result.inspection_day;
            sortData.confirmation_value = result.confirmation_value;
            sortData.confirmation_day = result.confirmation_day;
            sortDataList.push(sortData);
          }
        }

        const dataRows = sortDataList.map(({ tableData, ...row }) => {
          return Object.values(row);
        });

        const delimiter = ",";
        const data: any = [headerRow, ...dataRows]
          .map((e: any) => e.join(delimiter))
          .join("\n");

        let fileName = "TSCheckStoreEvaluationData_" + date;

        const exportFileName = `${fileName}.csv`;

        let convertData: any = new Uint8Array(
          Encoding.convert(Encoding.stringToCode(data), "SJIS", "UNICODE")
        );
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
          new Blob([convertData], { type: "text/csv" })
        );
        a.setAttribute("download", exportFileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .finally(() => {
        setExecuteFlg2(false);
      });
  };

  return (
    <>
      {addMonth === 0 ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ width: "220px", marginRight: "10px" }}
          onClick={() => getTSCheckData()}
          disabled={executeFlg ? true : false}
        >
          {!executeFlg ? "「個店毎の得点推移」CSV出力" : "CSV出力中"}
        </Button>
      ) : (
        ""
      )}

      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ width: "250px", marginRight: "10px" }}
        onClick={() => getStoreScoreData()}
        disabled={executeFlg2 ? true : false}
      >
        {!executeFlg2
          ? addMonth === 0
            ? "今月分「個店毎評価一覧」CSV出力"
            : "先月分「個店毎評価一覧」CSV出力"
          : "CSV出力中"}
      </Button>
    </>
  );
};
export default TSCheckStoreScoreDataButton;
